
import { Component, Vue, Prop } from "vue-property-decorator";
// import CustomSelectInput from '@/components/vui-luma/Ui/CustomSelectInput.vue';
// import UserStatus from '@/components/Profile/UserStatus.vue';
import UserInfoModal from "./UserInfoModal.vue";
import { readToggledTreeIds, readTreeUsersChildren } from "@/store/mlm/getters";
import { dispatchGetFirstLineUsersForUser, dispatchGetUserPurchases } from "@/store/mlm/actions";
import {
  commitSetToggledTreeIds,
  commitSetTreeUsersChildren,
} from "@/store/mlm/mutations";
import ReferralTableList from "./ReferralTableList.vue";
import {IUserPurchases} from "@/interfaces/mlm"
import IconArrow from "./IconArrow.vue";
import UiSmallLoader from "../Ui/UiSmallLoader.vue";
@Component({
  components: {
    UserInfoModal,
     ReferralTableList,
    IconArrow,
    UiSmallLoader
    // CustomSelectInput,
    // UserStatus,
  },
})
export default class ChildTreeTable extends Vue {
  // @ts-ignore
  @Prop({ required: true }) public readonly parent: any;
  // @ts-ignore
  @Prop({ required: true }) public readonly depth: number;

  public refUserInfo: any = null;

   public isShowUserInfoId = 0;
  public loadingPurchases = false;
  public userPurchases:IUserPurchases[] = []

  public page = 1;
  public pageForParent = 1;
  public currentUser: null | number = null;
  public loadingState: boolean = false;

  public childUsersResponse: any = {
    current: 0,
    count: 0,
    total: 0,
    next: null,
    previous: null,
    results: [],
  };

  public async toggleTeamItems(user, level) {
    const toggledTreeIds = this.toggledTreeIds;
    const userId = user.user.id;

    if (toggledTreeIds.includes(userId)) {
      // @ts-ignore
      const index = toggledTreeIds.indexOf(userId);
      if (index > -1) {
        toggledTreeIds.splice(index, 1);
      }
      // Сбрасываем текущего пользователя при сворачивании
      if (this.currentUser === userId) {
        this.currentUser = null;
        // Сбрасывать в дефолтное состояние:
        this.childUsersResponse = {
  current: 0, count: 0, total: 0,
  next: null, previous: null, results: []
};

this.closeChildren(userId);
      }
    } else {
      
      toggledTreeIds.push(userId);
      this.currentUser = userId;
      this.page = 1; // сбрасываем страницу при каждом открытии

      if (!(userId in this.treeUsersChildren)) {
      // Первая загрузка — делаем запрос
      const rowQuery = `?page=${this.page}&page_size=20`;
      const children = await dispatchGetFirstLineUsersForUser(this.$store, {
        data: { user: userId },
        rowQuery
      });

      this.childUsersResponse = children; // ← всегда обновляем
      let treeUsersChildren = { ...this.treeUsersChildren };
      treeUsersChildren[userId] = children;
      commitSetTreeUsersChildren(this.$store, treeUsersChildren);
      } else {
        // Данные уже в кеше — восстанавливаем childUsersResponse из store
        this.childUsersResponse = this.treeUsersChildren[userId];
      }
    }
  }

public closeChildren(userId: number, treeCache?: any) {
  // Берём переданный кеш или создаём копию один раз
  const treeUsersChildren = treeCache ?? { ...this.treeUsersChildren };
  
  if (userId in treeUsersChildren) {
    const children = treeUsersChildren[userId].results || [];
    
    children.forEach((child) => {
      const childId = child.user.id;
      
      const idx = this.toggledTreeIds.indexOf(childId);
      if (idx > -1) {
        this.toggledTreeIds.splice(idx, 1);
      }
      
      // Передаём тот же объект вглубь, не создаём новый
      this.closeChildren(childId, treeUsersChildren);
    });

    delete treeUsersChildren[userId];
    
    // Коммитим только на верхнем уровне (когда treeCache не передан)
    if (!treeCache) {
      commitSetTreeUsersChildren(this.$store, treeUsersChildren);
    }
  }
}

  public getFullName(fName, lName) {
    return `${fName} ${lName ? lName : ""}`;
  }

  get toggledTreeIds() {
    return readToggledTreeIds(this.$store);
  }

  public isLastToggled(id) {
    if (this.toggledTreeIds.includes(id)) {
      return this.toggledTreeIds[this.toggledTreeIds.length - 1] === id;
    }
    return false;
  }

  public async handleShowUserInfoByID(userId){
   if (userId && userId === this.isShowUserInfoId) {
    this.isShowUserInfoId = 0  // если кликнули повторно
  } else if (userId) {
    this.isShowUserInfoId = userId  // открыть новый
    this.loadingPurchases = true
      try {
        this.userPurchases = await dispatchGetUserPurchases(this.$store,{user_id: userId})
      } finally {
        this.loadingPurchases = false
      }
  } 
  }

  public async handleChangePage(page, force = false) {
    if (this.page !== page || force) {
      this.loadingState = true;
      this.page = page;
      const rowQuery = `?page=${this.page}&page_size=20`;
      if(this.currentUser !== null){
      let children = await dispatchGetFirstLineUsersForUser(this.$store, {
        data: {user: this.currentUser},
        rowQuery
      });
      this.childUsersResponse = children
      let treeUsersChildren = { ...this.treeUsersChildren };
     
        treeUsersChildren[this.currentUser] = children;
        commitSetTreeUsersChildren(this.$store, treeUsersChildren);
      }
      this.loadingState = false;
    }
    
  }

  public async handleChangePageForParent(page: number) {
  if (this.pageForParent === page) return;
  this.pageForParent = page;
  const rowQuery = `?page=${page}&page_size=20`;
  const children = await dispatchGetFirstLineUsersForUser(this.$store, {
    data: { user: this.parent.user.id },
    rowQuery
  });
  let treeUsersChildren = { ...this.treeUsersChildren };
  treeUsersChildren[this.parent.user.id] = children;
  commitSetTreeUsersChildren(this.$store, treeUsersChildren);
}

  get treeUsersChildren() {
    return readTreeUsersChildren(this.$store);
  }
}
